export const RESULT_LABELS = {
  loanAmount: "Calculated loan amount",
  monthlyEMI: "You'll have to pay",
};

export const CALCULATOR_TABS = {
  EMI: "emi",
  LOAN: "loan",
};
